// REQ-42 / MOD-13 — kullanıcı bazlı e-posta bildirim tercihi (self-service).
//
// BE endpoints (authenticated, RBAC izni YOK — yalnız çağıranın tercihi):
//   GET /api/v1/notifications/preferences → data.emailNotificationsEnabled
//   PUT /api/v1/notifications/preferences  body { emailNotificationsEnabled }
//
// Wire tip diğer bloklarla çakışmasın diye burada elle tanımlanır (generated
// api.ts'e dokunmuyoruz — notifications/analytics deseni).

import { http, unwrap, type ActionResponse } from './http';

interface NotificationPreferencesDtoWire {
  emailNotificationsEnabled?: boolean | null;
}

export interface NotificationPreferences {
  emailNotificationsEnabled: boolean;
}

const BASE = '/api/v1/notifications/preferences';

function mapPreferences(d: NotificationPreferencesDtoWire): NotificationPreferences {
  // Default true — BE varsayılanı da true; alan gelmezse güvenli tarafta kal.
  return { emailNotificationsEnabled: d.emailNotificationsEnabled ?? true };
}

export const notificationPreferencesApi = {
  async get(): Promise<NotificationPreferences> {
    const res = await http.get<ActionResponse<NotificationPreferencesDtoWire>>(BASE);
    return mapPreferences(unwrap(res));
  },

  async update(input: NotificationPreferences): Promise<NotificationPreferences> {
    const res = await http.put<ActionResponse<NotificationPreferencesDtoWire>>(BASE, {
      emailNotificationsEnabled: input.emailNotificationsEnabled,
    });
    return mapPreferences(unwrap(res));
  },
};
